export default "__VITE_ASSET__BwaaDPGt__"